import { ref, watch } from "vue";

const useDebounce = (value: any, delay = 1000) => {
  const debounced = ref(value.value);

  let timeout: number;

  watch(value, (newVal) => {
    clearTimeout(timeout);

    timeout = window.setTimeout(() => {
      debounced.value = newVal;
    }, delay);
  });

  return debounced;
}

export default useDebounce;
